<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">stethoscope</span>
      <p>
        Administra los médicos de la empresa: búsqueda, acceso al perfil,
        agenda y gestión del estado. El asistente guía el proceso de creación
        de un nuevo médico verificando los cupos disponibles en la suscripción.
      </p>
    </div>

    <!-- Búsqueda -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">search</span>
        Búsqueda de médicos
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in busquedas" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Estados -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Estados
      </h3>
      <div class="help-estados">
        <span class="help-estado-badge" style="background:#d4edda;color:#155724">Activo</span>
        <span class="help-estado-badge" style="background:#f8d7da;color:#721c24">Inactivo</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem;margin-top:0.5rem">
        Un médico <strong>Activo</strong> aparece en los selectores de citas
        y atenciones. Un médico <strong>Inactivo</strong> conserva su historial
        pero no está disponible para nuevas asignaciones.
      </p>
    </section>

    <!-- Acciones -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Asistente -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">smart_toy</span>
        Asistente de creación
      </h3>
      <p class="help-card-desc" style="padding:0 0.25rem">
        El ícono del asistente (imagen animada en la barra de herramientas)
        inicia el proceso guiado para registrar un nuevo médico. Antes de
        abrir el formulario, verifica automáticamente si la suscripción
        tiene cupos de usuario disponibles. Si no hay cupos, ofrece la
        opción de actualizar el plan de suscripción.
      </p>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Los campos de búsqueda son mutuamente excluyentes: al escribir en
        uno se limpia el otro. Si ambos están vacíos, el botón de búsqueda
        recarga todos los médicos de la empresa. Usa <strong>Ver Médico</strong>
        para editar los datos personales y <strong>Ver Agenda</strong> para
        gestionar los horarios y disponibilidad del médico.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaMedico",
  data() {
    return {
      busquedas: [
        {
          icon: "badge",
          titulo: "Por cédula",
          desc:   "Ingresa el número de documento del médico. Al escribir se limpia automáticamente el campo de nombre.",
        },
        {
          icon: "person_search",
          titulo: "Por nombre",
          desc:   "Escribe parte del nombre completo del médico. Al escribir se limpia automáticamente el campo de cédula.",
        },
        {
          icon: "list_alt",
          titulo: "Todos los registros",
          desc:   "Pulsa el botón de recarga para ver todos los médicos de la empresa sin filtros.",
        },
      ],
      acciones: [
        {
          icon:   "info",
          color:  "#0059cc",
          titulo: "Información del médico (editar)",
          desc:   "Muestra un resumen con el nombre completo, especialidad, documento de identidad y número de registro médico. Se abre desde el ícono de edición de la tabla.",
        },
        {
          icon:   "person",
          color:  "#198754",
          titulo: "Ver Médico",
          desc:   "Navega al perfil completo de la persona asociada al médico para editar sus datos personales, contacto y demás información.",
        },
        {
          icon:   "event",
          color:  "#6f42c1",
          titulo: "Ver Agenda",
          desc:   "Navega a la agenda del médico para gestionar sus horarios de atención, disponibilidad y bloqueos.",
        },
        {
          icon:   "delete",
          color:  "#dc3545",
          titulo: "Eliminar",
          desc:   "Elimina el registro del médico de forma permanente. Si tiene atenciones o citas asociadas, considera desactivarlo en lugar de eliminarlo.",
        },
        {
          icon:   "download",
          color:  "#fd7e14",
          titulo: "Exportar Excel",
          desc:   "Descarga la lista actual de médicos en formato Excel.",
        },
        {
          icon:   "refresh",
          color:  "#6c757d",
          titulo: "Recargar",
          desc:   "Recarga la lista completa de médicos de la empresa.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>